// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/

.closebutton {
  position: relative;
}

a.gridLinkclass {
  text-decoration-line: underline;
  cursor: pointer;
  color: var(--hyperlinkFont-color);
}

.modalmainpage {
  display: block;
  padding: 0 0.5%;
  background-color: white;
  height: 322px;
  position: absolute;
  /* margin-top: -5%; */
  width: 59.2%;
  z-index: 2002;
  border-radius: 10px;
}
.modalmainpage.bellNotification {
  padding: 0 1% 0 1%;
}

.modalmainpage.notestab {
  height: 320px;
}
.modalmainpage.notestabAdd {
  height: 340px;
}

.modalmainpage_approvalQueueList {
  display: grid;
  grid-template-rows: min-content 1fr min-content;
  padding: 20px;
  background-color: white;
  height: 892px;
  position: absolute;
  width: 985px;
  z-index: 2002;
  border-radius: 10px;
  gap: 20px;
}

.notes_dialog_dataSaveWarning {
  z-index: 2003;
}

#dialog_templateReject {
  z-index: 2006;
}

.modalmainpage .previewContainer_main {
  height: 600px;
}

.modalbody {
  z-index: 2002;
  position: absolute;
  height: 78%;
  width: 100%;
  margin-top: 0.5%;
  margin-left: 1.25%;
}

.modalbodyApprovalQueue {
  z-index: 2002;
  height: 100%;
  overflow: hidden;
}
.modalmainpage_approvalQueueList
  .modalbodyApprovalQueue
  .previewContainer_main {
  height: 100%;
  overflow: hidden;
}

.NotesTab .modalbody {
  width: 96%;
}

.NotesTab .searchmadaltitlebar {
  width: 98.5%;
}

.MuiDialogTitle-root .MuiTypography-h6 {
  font-size: var(--dialogTitleFontSize);
  font-family: var(--default-FontName);
  font-weight: var(--header-FontWeight);
  line-height: 1.6;
  letter-spacing: 0.0075em;
}

.sendCorrespondenceAddress .modaltitle {
  margin-top: 0 !important;
}
.modaltitle {
  margin-top: 5%;
  /* margin-left: 2.5%; */
  font-size: var(--default-NotificationContentHeadingFontSize);
  font-family: var(--default-FontName);
  color: var(--default-FontColour);
  font-weight: var(--header-FontWeight);
  overflow: hidden;
  height: auto;
  text-wrap: wrap;
}
.modalmainpage_approvalQueueList .searchmadaltitlebar .modaltitle {
  font-family: var(--default-FontName);
  font-weight: bold;
  color: var(--default-FontColour);
  font-size: var(--mainheading-FontSize);
  font-weight: var(--header-FontWeight);
  margin-top: 0;
  overflow-wrap: anywhere;
  /* margin-left: 2.5%; */
}

.sendCorrespondenceAddress .closeicon {
  margin-top: 0px !important;
}

.closeicon {
  /* margin-right: 0.5%; */
  cursor: pointer;
  font-family: var(--default-FontName);
  color: black;
  /* font-weight: bold; */
  margin-top: 40px;
  margin-right: 3px;
}
.modalmainpage_approvalQueueList .searchmadaltitlebar .closeicon {
  cursor: pointer;
  font-family: var(--default-FontName);
  color: black;
  margin-top: 0;
  margin-right: 0;
}

.butZoom {
  display: flex;
  align-items: center;
  gap: 2.64vh;
}

.closeicon_reject {
  cursor: pointer;
  font-family: var(--default-FontName);
  color: black;
  /* font-weight: bold; */
  margin-top: -7%;
  margin-left: 100%;
}

/* #dialog_templateReject.MuiDialog-root.MuiModal-root .MuiDialog-container.MuiDialog-scrollPaper .MuiPaper-root {
  width: 38.281vw;
  height: 35.017vh;
} */

#dialog_templateReject .MuiDialogContent-root {
  height: 14.514vh;
}

#dialog_templateReject .textbox {
  height: 99%;
}

#dialog_templateReject .MuiPaper-root {
  height: 45vh;
  width: 50vw;
  display: grid;
  grid-template-rows: min-content 1fr min-content;
  row-gap: 0px;
}

#dialog_templateReject #txt_reject {
  height: 25.2vh !important;
  width: 100%;
  margin: 0px;
}

#dialog_templateReject .MuiDialogTitle-root {
  padding-left: 0px;
  padding-top: 8px;
}

#dialog_templateReject .MuiDialogContent-root,
#dialog_templateReject .Text-field-container,
#dialog_templateReject .multilinetextbox {
  height: 100%;
}

#dialog_templateReject .MuiDialogContent-root .MuiInputBase-root,
#dialog_templateReject .MuiDialogContent-root .MuiFormControl-root {
  height: 100%;
}

.sendCorrespondenceAddress .searchmadaltitlebar {
  width: unset;
}
.searchmadaltitlebar {
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: nowrap;
  height: 15%;
  margin-left: 1.25%;
  width: 100%;
  justify-content: space-between;
}

.modalmainpage_approvalQueueList .searchmadaltitlebar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  flex-wrap: nowrap;
  height: auto;
  width: 100% !important;
  margin: 0px !important;
}

.modalmainpage_approvalQueueList .previewContainer {
  height: 100%;
  overflow-y: auto;
  margin: 0px 0px 0px 0px;
  border: 1px solid #bcbcbc;
  border-radius: 4px;
}

.modalmainpage_approvalQueueList .sendCorrespondenceSaveCancel {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.notesmaindiv {
  padding-top: 2%;
  height: 100%;
  width: 100%;
  grid-template-rows: min-content 1fr;
  display: grid;
  gap: 10px;
}
.notesmaindiv .textbox {
  display: grid;
  align-content: space-around;
}

.notesmaindiv .MuiInputBase-root #txt_notesdescription.Mui-disabled {
  font-size: var(--default-FontSize);
  font-family: var(--default-FontName);
  font-weight: var(--default-FontWeight);
  color: var(--default-FontColour);
  -webkit-text-fill-color: unset;
  height: 168px !important;
  overflow: auto !important;
  padding: 5px 0px 0px -1px;
}

.notesmaindiv .textbox .MuiFormControl-root .MuiInputBase-root {
  margin-top: 10px;
}

.addNotesmaindiv .addNotes {
  height: 131px;
  width: 100%;
}

.modalbody .addNotesmaindiv {
  height: 322px;
}

#txt_note {
  height: 131px !important;
  min-height: 131px !important;
  width: 100%;
  resize: none;
  border-style: hidden;
}

.modalmainpage.sendCorrespondenceAddress .modalbody {
  width: 96%;
}
.modalmainpage.sendCorrespondenceAddress .searchmadaltitlebar .closeicon {
  margin-right: 7px;
}
.modalmainpage.notestabAdd .modalbody {
  width: 96%;
}
.modalmainpage.notestabAdd .searchmadaltitlebar .closeicon {
  margin-right: 20px;
}

.addNotesmaindiv .span_Label {
  font-size: var(--default-FontSize);
  font-family: var(--default-FontName);
  font-weight: var(--default-FontWeight);
  color: var(--default-FontColour);
  margin-top: 5px;
}

#dialog_templateReject {
  font-family: var(--default-FontName);
}

.MuiDialogTitle-root {
  margin-left: -28px;
  font-family: var(--default-FontName);
}

.addNotesmaindiv .required {
  color: var(--required-color);
}

.addNotesmaindiv .addNotesButton {
  float: right;
  display: flex;
  gap: 15px;
}

.addNotessubheaderdiv {
  margin-top: 20px;
  margin-bottom: 15px;
}

.notes.dataSaveWarning.MuiModal-root {
  z-index: 2007 !important;
}

.sendCorrespondenceAddress .sendCorrespondenceAddressButton {
  float: right;
  display: flex;
  gap: 12px;
  margin-top: 21px;
}

.sendCorrespondenceAddress .sendCorrespondenceAddressGrid {
  height: 260px;
}

.modalmainpage.sendCorrespondenceAddress {
  height: 405px;
}

.modalmainpage_approvalQueueList .zoomInicon {
  cursor: pointer;
}

.modalmainpage_approvalQueueList .zoomOuticon {
  cursor: pointer;
}

.title_reject {
  font-size: var(--sub-header-FontSize);
  font-family: var(--default-FontName);
}

#txt_reject {
  resize: none;
}

.MuiDialog-root.MuiModal-root {
  z-index: 2008;
}

div[disabled] {
  pointer-events: none;
  opacity: 0.7;
}
.modalmainpage_approvalQueueList .searchmadaltitlebar .headericonright {
  display: flex;
  gap: 2.64vh;
}
.modalmainpage_approvalQueueList .approvalQueueButtons {
  display: flex;
  justify-content: space-between;
}
.modalmainpage_approvalQueueList
  .approvalQueueButtons
  .approvalQueueButtonsLeft {
  display: flex;
  gap: 10px;
}
.bellNotification.modalmainpage
  .searchmadaltitlebar
  .closeicon
  .MuiSvgIcon-root {
  font-size: 1.5rem;
}
.divMainBellNotificationMessage {
  height: 100%;
  display: grid;
  grid-template-rows: 1fr min-content;
  gap: 5px;
  padding-top: 20px;
}

.divMainBellNotificationMessage .divBellNotificationMessage {
  font-size: var(--default-FontSize);
  font-style: normal;
  font-weight: var(--label-FontWeight);
  font-size: var(--label-FontSize);
  line-height: 21px;
  color: #333333;
  white-space: break-spaces;
  text-align: justify;
  /* margin-top: 30px; */
  overflow: auto;
  /* height: 60%; */
}
.divBellNotificationMessage .bellNotificationMessageText {
  margin-top: 10px;
  word-break: break-word;
  line-height: 29px;
}
.modalmainpage.bellNotification .searchmadaltitlebar {
  height: 20%;
}
.modalmainpage.bellNotification {
  width: 735px;
  height: 30vh;
  background: #ffffff;
  border-radius: 8px;
}
.bellNotification .modalbody {
  margin: 0px;
  width: 100%;
  padding: 0px 10px 0px 10px;
  position: relative;
}

.divMainBellNotificationMessage .notificationContentDate {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: var(--default-FontSize);
  color: #333333;
  margin: 0px 0px 15px 0px;
}

.addZone_field_col {
  display: grid;
  grid-template-columns: 180px auto;
  font-family: var(--default-FontName);
  font-weight: var(--header-FontWeight);
  font-size: var(--default-FontSize);
  line-height: 35px;
  width: 100% !important;
  margin-right: 300px;
  /* margin: 7px 0px 0px 0px; */
  height: 56px;
}

.modalmainpage.addZone {
  width: 765px;
  /* height: 47.1vh; */
  height: auto;
}
.backdrop.MuiBackdrop-root {
  z-index: 2007 !important;
}

.divZonePopup {
  margin: 30px 30px 0px 20px;
  display: grid;
  grid-template-rows: min-content min-content min-content min-content;
  gap: 7px;
}
.divZonePopup .mandatorySymbol {
  color: #ff0000;
}

.divZoneMainPopup .divZoneButton {
  display: grid;
  grid-template-columns: min-content min-content;
  justify-content: end;
  gap: 10px;
  padding: 20px 30px 0px 0px;
}
.divZoneMainPopup .autoCompleteLazyLoadctrl .colWiseControl {
  gap: 0px !important;
}
.divZoneMainPopup
  .divZonePopup
  .addZone_field_col
  .autoCompleteLazyLoadctrl
  .fieldAlert {
  display: block;
  height: fit-content;
}
.modalmainpage.addZone .searchmadaltitlebar {
  display: flex;
  justify-content: space-around;
  gap: 520px;
}
.modalmainpage.addZone .searchmadaltitlebar .closeicon {
  margin-right: 7px;
  cursor: pointer;
}

.MuiBackdrop-root.backdrop.addZoneBackdrop {
  z-index: 1000 !important;
}
.MuiBackdrop-root.backdrop.WarrantExecutedPopupBackdrop {
  z-index: 1000 !important;
}

.divZonePopup .MuiFormLabel-root {
  display: none !important;
}

.divZonePopup .textbox .colWiseControl {
  gap: 3px;
}
.divZoneMainPopup
  .divZonePopup
  .MuiInputBase-root.MuiInput-root.MuiInput-underline.MuiInputBase-colorPrimary.MuiInputBase-formControl.MuiInputBase-sizeSmall.MuiInputBase-adornedStart.MuiInputBase-adornedEnd {
  background-color: var(--inputbackgroundColor);
  border: 1px solid #b6b6b6;
}
.divZoneMainPopup .divZonePopup input#ac_inputAutocompleteLazyLoad {
  background-color: var(--inputbackgroundColor);
  border: 0px solid #b6b6b6;
}
.divZoneMainPopup
  .divZonePopup
  .addZone_field_col
  .autoCompleteLazyLoadctrl
  .autoCompleteLazyLoadinputDiv {
  border: 1px solid;
  display: flex;
  flex-direction: row;
  background-color: var(--inputbackgroundColor);
  border: 1px solid #b6b6b6;
  box-sizing: border-box;
  border-radius: 4px;
  align-items: center;
}

.modalmainpage.addZone .modalbody {
  position: relative;
  padding: 0% 0% 4% 0%;
}

.modalmainpage.addZone .modaltitle {
  margin-left: -2%;
}

.modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)
  .searchmadaltitlebar
  .modaltitle {
  font-weight: var(--header-FontWeight);
  font-size: var(--pcnHeaderFontSize);
}

.modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup) {
  width: 750px;
  height: auto;
  padding: 0% 1% 1.8% 1%;
}
.modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup) .modalbody {
  position: initial;
  height: auto;
}
.modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)
  .modalbody
  .messageModalRadio {
  border-top: 1px solid #ececec;
  border-bottom: 1px solid #ececec;
  width: 700px;
  height: auto;
  margin: 2% 0% 0% 0%;
  display: grid;
  align-content: space-evenly;
}
.modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)
  .modalbody
  .messageModalRadio
  .RadioGroupControl
  span.MuiTypography-root.MuiTypography-body1.MuiFormControlLabel-label {
  margin-right: 96px;
}
.modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)
  .modalbody
  .messageModalRadio
  .RadioGroupControl {
  margin: 3% 0% 3% 0%;
}

.modalmainpage.modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)
  .searchmadaltitlebar
  .modaltitle {
  margin-top: 1%;
}
.modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)
  .searchmadaltitlebar
  .closeicon {
  margin-top: 10px;
}

.divWarrantExecutedPopupButton {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin: 3% 0% 0% 0%;
  padding: 0% 3% 0% 0%;
}
.modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)
  .modalbody
  .divWarrantExecutedPopupButton
  .WarrantExecutedPopupSaveCancel {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}
.modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)
  .searchmadaltitlebar
  .closeicon {
  margin-right: 1%;
}
.modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)
  .modalbody
  .messageModalRadio
  .divSomeRejected
  .divSearchCase {
  display: flex;
  justify-content: space-between;
}
.modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)
  .modalbody
  .messageModalRadio
  .divSomeRejected
  .divSearchCase
  .divbtnSearchCase {
  display: flex;
  gap: 10px;
  margin: 3% 0% 0% 0%;
}
.divtxtSearchCase {
  width: 100%;
  margin: 3% 0% 0% 0%;
}
.modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)
  .modalbody
  .messageModalRadio
  .divSomeRejected
  .divSearchCase
  .divtxtSearchCase
  .textbox {
  width: 98%;
}
.modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)
  .modalbody
  .messageModalRadio
  .divSomeRejected
  .divSearchCase
  .divtxtSearchCase
  .textbox
  .MuiInputBase-root {
  height: 40px;
  background: #fbfbfb;
  border: 1px solid #b6b6b6;
  border-radius: 4px;
}
.divSomeRejected
  .divSearchCase
  .divtxtSearchCase
  .textbox
  input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  -webkit-box-shadow: 0 0 0 1000px #fbfbfb inset !important;
}
.divSomeRejected .divSearchResultMain {
  border: 1px solid #b6b6b6;
  border-radius: 6px;
  margin: 3% 0% 0% 0%;
}
.divSearchResultMain .divNoRecords {
  font-family: var(--default-FontName);
  font-weight: var(--default-FontWeight);
  font-size: var(--tooltipFontSize);
  display: flex;
  justify-content: space-around;
  color: #b6b6b6;
  /* padding: 1.03vh 1.56vw 1.03vh 1.56vw; */
  height: 38.5px;
}
.divSomeRejected .divSearchResult {
  display: grid;
  grid-template-columns: 1fr 1fr 1.2fr 0.8fr;
  width: 100%;
  justify-content: space-between;
  padding: 2.06vh 1.56vw 2.06vh 1.56vw;
  align-items: flex-end;
}
.divAddSearchResult .btn--primary.button.MuiButton-root {
  width: 112px;
  padding: 11px 6px;
  gap: 10px;
}
.divSomeRejected .divSearchResult.divSearchResultNoRecords {
  padding: 2.06vh 1.56vw 0px 1.56vw;
}
.divSomeRejected .divSearchResult .divSearchResultHeading {
  font-family: var(--default-FontName);
  font-style: normal;
  font-weight: var(--listHeaderFontWeight);
  font-size: var(--label-FontSize);
  line-height: 21px;
  color: #333333;
  border-right: 1px solid #ececec;
  margin-left: 5%;
  /* margin-top: 5%;
  margin-bottom: 15%; */
}
.divSomeRejected .divSearchResult .divSearchResultSub {
  display: flex;
  flex-direction: column;
  gap: 1.55vh;
}
.divSomeRejected .divSearchResult .divSearchResultData {
  font-family: var(--default-FontName);
  font-style: normal;
  font-weight: var(--default-FontWeight);
  font-size: var(--default-FontSize);
  line-height: 21px;
  color: #333333;
  margin-left: 5%;
  /* margin-bottom: 5%; */
}

.modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)
  .modalbody
  .messageModalRadio
  .divSomeRejected
  .divAddSearchResult {
  direction: rtl;
  margin: 2% 0% 0% 0%;
}
.modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)
  .modalbody
  .messageModalRadio
  .divSomeRejected
  .divRejectMain
  .divRejectTitle {
  font-family: var(--default-FontName);
  font-style: normal;
  font-weight: var(--header-FontWeight);
  font-size: var(--pcnHeaderFontSize);
  line-height: 24px;
  color: #333333;
  margin: 0% 0% 1% 0%;
}
.modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)
  .modalbody
  .messageModalRadio
  .divSomeRejected
  .divRejectMain
  .divRejectSub {
  border: 1px solid #b6b6b6;
  border-radius: 6px;
  padding: 0px 10px 0px 10px;
  margin-bottom: 3%;
}
.modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)
  .modalbody
  .messageModalRadio
  .divSomeRejected
  .divRejectMain
  .divRejectSub
  .divRejectSubTitle {
  font-family: var(--default-FontName);
  font-style: normal;
  font-weight: var(--header-FontWeight);
  font-size: var(--label-FontSize);
  line-height: 21px;
  color: #333333;
  border-bottom: 1px solid #ececec;
  padding: 1% 0% 1% 0%;
}
.modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)
  .modalbody
  .messageModalRadio
  .divSomeRejected
  .divRejectMain
  .divRejectSub
  .divRejectList {
  display: grid;
  /* justify-content: space-between; */
  margin: 2% 0% 2% 0%;
  font-family: var(--default-FontName);
  font-style: normal;
  font-weight: var(--default-FontWeight);
  font-size: var(--default-FontSize);
  line-height: 21px;
  color: #333333;
  max-height: 280px;
  min-height: 28px;
  overflow: auto;
}

.divSomeRejected
  .divAddSearchResult
  span.MuiButton-endIcon.MuiButton-iconSizeMedium {
  margin: 0px;
}
.divSomeRejected
  .divRejectMain
  .divRejectSub
  .divRejectList
  .divRejectListItem {
  /* display: flex;
  justify-content: space-between; */

  justify-content: space-between;
}
.divSomeRejected
  .divRejectMain
  .divRejectSub
  .divRejectList
  .divRejectListItem
  .divRejectListItemRow {
  display: flex;
  justify-content: space-between;
  font-family: var(--default-FontName);
  font-weight: var(--default-FontWeight);
  font-size: var(--default-FontSize);
}
.divRejectListItemRow.divNoRecordsMain {
  display: flex;
  justify-content: center !important;
}
.divSomeRejected
  .divRejectMain
  .divRejectSub
  .divRejectList
  .divRejectListItem
  .divRejectListItemRow
  .divNoRecords {
  font-family: var(--default-FontName);
  font-weight: var(--default-FontWeight);
  font-size: var(--tooltipFontSize);
  display: flex;
  justify-content: space-around;
  color: #b6b6b6;
}

.modalmainpage:where(.DebtExecuted) {
  width: 39.58vw;
  height: 26.63vh;
  padding: 0% 1% 2% 1%;
}

.modalmainpage:where(.WarrantProcessedPopup, .DebtExecuted)
  .searchmadaltitlebar
  .modaltitle {
  font-weight: var(--header-FontWeight);
  font-size: var(--pcnHeaderFontSize);
}
.modalmainpage:where(.WarrantProcessedPopup, .DebtExecuted)
  .modalbody
  .messageModalRadio {
  border-top: 1px solid #ececec;
  border-bottom: 1px solid #ececec;
  width: 700px;
  height: auto;
  margin: 2% 0% 2.5% 0%;
  display: grid;
  align-content: space-evenly;
}
.divWarrantExecutedMain .divSearchResult {
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr 0.5fr;
  width: 98%;
  border-top: 1px solid #ececec;
  border-bottom: 1px solid #ececec;
  margin: 3% 0% 0% 0%;
  padding: 0px 0px 8px 0px;
  align-items: flex-end;
  justify-content: space-between;
}
.modalmainpage:where(.WarrantProcessedPopup, .DebtExecuted) .modalbody {
  position: initial;
  height: auto;
}
.divWarrantExecutedMain .divSearchResult .divSearchResultHeading {
  font-family: var(--default-FontName);
  font-style: normal;
  font-weight: var(--listHeaderFontWeight);
  font-size: var(--label-FontSize);
  line-height: 21px;
  color: #333333;
  margin-top: 1.5vh;
  margin-bottom: 1.678vh;
}
.divWarrantExecutedMain .divSearchResult .divSearchResultData {
  font-family: var(--default-FontName);
  font-style: normal;
  font-weight: var(--default-FontWeight);
  font-size: var(--default-FontSize);
  line-height: 21px;
  color: #333333;
  margin-bottom: 1.5vh;
}
.modalmainpage:where(.WarrantProcessedPopup, .DebtExecuted)
  .searchmadaltitlebar
  .closeicon {
  margin-right: 1.3%;
}

.svg-buttonActive {
  cursor: pointer;
}
.hideMainPopup .modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup) {
  display: none;
}

.modalmainpage:where(.WarrantProcessedPopup, .DebtExecuted)
  .searchmadaltitlebar
  .modaltitle {
  margin-top: 0%;
}
.modalmainpage:where(.WarrantProcessedPopup, .DebtExecuted)
  .searchmadaltitlebar
  .closeicon {
  /* margin-top: 3%; */
  margin-top: 0%;
  align-self: self-end;
}

.modalmainpage:where(.WarrantProcessedPopup, .DebtExecuted)
  .searchmadaltitlebar
  .modaltitle {
  margin-top: 0%;
}
.modalmainpage:where(.WarrantProcessedPopup, .DebtExecuted)
  .searchmadaltitlebar
  .closeicon {
  /* margin-top: 3%; */
  margin-top: 0%;
  align-self: self-end;
}

.modalmainpage:where(.WarrantProcessedPopup, .DebtExecuted)
  .searchmadaltitlebar {
  margin-top: 2%;
}
.modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)
  .searchmadaltitlebar {
  margin-top: 2%;
}
.modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)
  .modalbody
  .messageModalRadio
  .RadioGroupControl
  .radioGroupControl
  .MuiFormControlLabel-root {
  margin-right: 16px;
}

.modalmainpage.bellNotification .searchmadaltitlebar .closeicon {
  margin-top: 40px;
  margin-right: 15px;
}
.modalmainpage.SearchBar {
  height: 70vh;
  width: 85vw;
}
.modalmainpage.SearchBar .modalbody .searchBarModalbody {
  height: 58vh;
  width: 82vw;
  margin-top: 5px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.modalmainpage.SearchBar .searchmadaltitlebar .modaltitle {
  margin-top: 15px;
}
.modalmainpage.SearchBar .searchmadaltitlebar .closeicon {
  margin-top: 15px;
  margin-right: 25px;
}

.modalmainpage:where(.DebtProcessedPopup, .WarrantProcessedPopup) .modalbody {
  width: 98.5%;
}
.modalmainpage:where(.DebtProcessedPopup, .WarrantProcessedPopup)
  .searchmadaltitlebar {
  margin-left: 0px;
}
.modalmainpage:where(.DebtProcessedPopup, .WarrantProcessedPopup) .modaltitle {
  margin-left: 10px;
}
.modalmainpage:where(.DebtProcessedPopup, .WarrantProcessedPopup) {
  height: 300px;
}

/* DomainURL -- Start */
.addDomainURLDiv {
  padding-top: 2%;
  height: 100%;
  width: 91%;
  grid-template-rows: min-content 1fr;
  display: grid;
  gap: 20px;
}
.addDomainURLDiv .textbox {
  display: grid;
  align-content: space-around;
}

.addDomainURLDiv .MuiInputBase-root #txt_notesdescription.Mui-disabled {
  font-size: var(--default-FontSize);
  font-family: var(--default-FontName);
  font-weight: var(--default-FontWeight);
  color: var(--default-FontColour);
  -webkit-text-fill-color: unset;
  height: 168px !important;
  overflow: auto !important;
  padding: 5px 0px 0px -1px;
}

.addDomainURLDiv .textbox .MuiFormControl-root .MuiInputBase-root {
  margin-top: 20px;
}

.addDomainURLDiv .domainURLPopupSaveCancel {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
/* DomainURL -- End */
/* Branding -- Start */
.brandingURLDiv {
  padding-top: 2%;
  height: 100%;
  width: 62%;
  grid-template-rows: min-content 1fr;
  display: grid;
  gap: 20px;
}
.brandingURLDiv .textbox {
  display: grid;
  align-content: space-around;
}

.brandingURLDiv .MuiInputBase-root #txt_notesdescription.Mui-disabled {
  font-size: var(--default-FontSize);
  font-family: var(--default-FontName);
  font-weight: var(--default-FontWeight);
  color: var(--default-FontColour);
  -webkit-text-fill-color: unset;
  height: 168px !important;
  overflow: auto !important;
  padding: 5px 0px 0px -1px;
}

.brandingURLDiv .textbox .MuiFormControl-root .MuiInputBase-root {
  margin-top: 20px;
}

.brandingPopupSaveCancel {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
/* Branding -- End */

.divLine {
  width: 100%;
  border: 1px solid var(--line-BorderColor);
}
.divMainBellNotificationMessage .divOrgContract {
  font-weight: var(--default-FontWeight);
  font-size: var(--default-FontSize);
  color: #333333;
  display: flex;
  margin: 15px 0px 15px 0px;
  align-items: center;
  column-gap: 140px;
  line-height: 25px;
}

.divNotificationTitle {
  font-weight: var(--dialogTitleFontWeight);
  font-size: var(--dialogTitleFontSize);
  color: #333333;
  display: flex;
  align-items: center;
  column-gap: 10px;
}

@media (min-width: 491px) and (max-width: 1024px) {
  .modalmainpage_approvalQueueList {
    height: 570px;
  }
  .modalmainpage.addZone {
    /* height: 71.14vh; */
    height: auto;
  }
  .divZoneMainPopup .divZoneButton {
    padding: 20px 30px 0px 0px;
  }

  .divWarrantExecutedPopupButton {
    padding: 0% 2% 0% 0%;
  }
  .modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)
    .modalbody
    .messageModalRadio {
    width: 712px;
  }
  .modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)
    .modalbody
    .messageModalRadio
    .divSomeRejected
    .divRejectMain
    .divRejectSub
    .divRejectList {
    max-height: 50px;
  }
  .modalmainpage:where(.WarrantProcessedPopup, .DebtExecuted) {
    height: 33vh;
    padding: 0% 0% 0% 1%;
  }

  .modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)
    .modalbody
    .divWarrantExecutedPopupButton {
    margin: 2% 0% 0% 0%;
  }
  .modalmainpage:where(.WarrantProcessedPopup, .DebtExecuted) .modalbody {
    width: 98%;
  }
  .modalmainpage:where(.WarrantProcessedPopup, .DebtExecuted)
    .modalbody
    .divWarrantExecutedMain
    .divWarrantExecutedPopupButton {
    margin: 2% 0% 0% 0%;
  }

  .modalmainpage:where(.WarrantProcessedPopup, .DebtExecuted) {
    width: 55.58vw;
  }
  .modalmainpage:where(.WarrantProcessedPopup, .DebtExecuted)
    .searchmadaltitlebar
    .closeicon {
    margin-right: 1.5%;
  }
  .modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)
    .searchmadaltitlebar
    .closeicon {
    margin-right: 2%;
  }
  .modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)
    .modalbody
    .messageModalRadio
    .RadioGroupControl
    .radioGroupControl
    .MuiFormControlLabel-root {
    margin-right: 38px;
  }
  .modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)
    .searchmadaltitlebar {
    margin-top: 0%;
  }
  .modalmainpage.SearchBar .searchmadaltitlebar .closeicon {
    margin-top: 22px;
    margin-right: 10px;
  }

  .modalmainpage:where(.DebtProcessedPopup, .WarrantProcessedPopup) .modalbody {
    width: 98.5%;
  }
  .modalmainpage:where(.DebtProcessedPopup, .WarrantProcessedPopup)
    .searchmadaltitlebar {
    margin-left: 0px;
  }
  .modalmainpage:where(.DebtProcessedPopup, .WarrantProcessedPopup)
    .modaltitle {
    margin-left: 10px;
  }
  .modalmainpage:where(.DebtProcessedPopup, .WarrantProcessedPopup) {
    height: 220px;
  }
  .modalmainpage.bellNotification {
    height: 44vh;
  }
}

@media (min-width: 1025px) and (max-width: 1360px) {
  .modalmainpage_approvalQueueList {
    height: 580px;
  }
  .modalmainpage.addZone {
    /* height: 70.14vh; */
    height: auto;
  }
  .divZoneMainPopup .divZoneButton {
    padding: 20px 30px 0px 0px;
  }
  .modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)
    .searchmadaltitlebar
    .closeicon {
    margin-right: 2%;
  }
  .divWarrantExecutedPopupButton {
    padding: 0% 2.5% 0% 0%;
  }
  .modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)
    .modalbody
    .messageModalRadio
    .divSomeRejected
    .divRejectMain
    .divRejectSub
    .divRejectList {
    max-height: 50px;
  }
  .modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)
    .modalbody
    .messageModalRadio {
    width: 705px;
  }
  .modalmainpage:where(.WarrantProcessedPopup, .DebtExecuted)
    .searchmadaltitlebar
    .modaltitle {
    margin-top: 0%;
  }
  .modalmainpage:where(.WarrantProcessedPopup, .DebtExecuted)
    .searchmadaltitlebar
    .closeicon {
    margin-top: 0%;
    margin-right: 1%;
  }
  .divWarrantExecutedMain .divSearchResult {
    margin: 3% 0% 0% 0%;
  }
  #dialog_templateReject .MuiPaper-root {
    height: 50vh;
  }

  #dialog_templateReject #txt_reject {
    height: 22vh !important;
  }
  .modalmainpage:where(.WarrantProcessedPopup, .DebtExecuted) {
    height: 32vh;
  }
  .modalmainpage:where(.WarrantExecutedPopup, .DebtDebtExecutedPopupProcessed)
    .modalbody
    .divWarrantExecutedPopupButton {
    margin: 2% 0% 0% 0%;
  }
  .divWarrantExecutedPopupButton {
    margin: 3% 0% 0% 0%;
  }
  .modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)
    .modalbody
    .messageModalRadio
    .RadioGroupControl
    .radioGroupControl
    .MuiFormControlLabel-root {
    margin-right: 35px;
  }
  .modalmainpage.SearchBar .searchmadaltitlebar .closeicon {
    margin-top: 20px;
    margin-right: 17px;
  }

  .modalmainpage:where(.DebtProcessedPopup, .WarrantProcessedPopup) .modalbody {
    width: 98.5%;
  }
  .modalmainpage:where(.DebtProcessedPopup, .WarrantProcessedPopup)
    .searchmadaltitlebar {
    margin-left: 0px;
  }
  .modalmainpage:where(.DebtProcessedPopup, .WarrantProcessedPopup)
    .modaltitle {
    margin-left: 10px;
  }
  .modalmainpage:where(.DebtProcessedPopup, .WarrantProcessedPopup) {
    height: 240px;
  }
  .modalmainpage.bellNotification {
    height: 44vh;
  }
}

@media (min-width: 1361px) and (max-width: 1536px) {
  .modalmainpage.SearchBar .searchmadaltitlebar .modaltitle {
    margin-top: 7px !important;
  }

  .modalmainpage:where(.DebtProcessedPopup, .WarrantProcessedPopup) .modalbody {
    width: 98.5%;
  }
  .modalmainpage:where(.DebtProcessedPopup, .WarrantProcessedPopup)
    .searchmadaltitlebar {
    margin-left: 0px;
  }
  .modalmainpage:where(.DebtProcessedPopup, .WarrantProcessedPopup)
    .modaltitle {
    margin-left: 10px;
  }
  .modalmainpage:where(.DebtProcessedPopup, .WarrantProcessedPopup) {
    height: 255px;
  }
  .modalmainpage.bellNotification {
    height: 36vh;
  }
}

@media (min-width: 1361px) and (max-width: 1600px) {
  .modalmainpage_approvalQueueList {
    height: 685px;
  }
  .modalmainpage.addZone {
    /* height: 58vh; */
    height: auto;
  }
  .divZoneMainPopup .divZoneButton {
    padding: 15px 30px 0px 0px;
  }
  .modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)
    .searchmadaltitlebar
    .closeicon {
    margin-right: 2%;
  }
  .divWarrantExecutedPopupButton {
    padding: 0% 2.5% 0% 0%;
  }
  .modalmainpage:where(.WarrantProcessedPopup, .DebtExecuted) {
    height: 29.5vh;
  }
  .modalmainpage:where(.WarrantProcessedPopup, .DebtExecuted)
    .searchmadaltitlebar
    .modaltitle {
    margin-top: 0%;
  }
  .modalmainpage:where(.WarrantProcessedPopup, .DebtExecuted)
    .searchmadaltitlebar
    .closeicon {
    /* margin-top: 3%; */

    margin-top: 0%;
    align-self: self-end;
  }

  .divWarrantExecutedMain .divSearchResult {
    margin: 3% 0% 0% 0%;
  }
  .modalmainpage:where(.WarrantProcessedPopup, .DebtExecuted)
    .modalbody
    .divWarrantExecutedMain
    .divWarrantExecutedPopupButton {
    margin: 3% 0% 0% 0%;
  }
  .modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)
    .modalbody
    .divWarrantExecutedPopupButton {
    margin: 3% 0% 0% 0%;
  }
  .modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)
    .modalbody
    .messageModalRadio
    .divSomeRejected
    .divRejectMain
    .divRejectSub
    .divRejectList {
    max-height: 145px;
  }
  .modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)
    .modalbody
    .messageModalRadio
    .RadioGroupControl
    .radioGroupControl
    .MuiFormControlLabel-root {
    margin-right: 28px;
  }
  .modalmainpage.SearchBar .searchmadaltitlebar .modaltitle {
    margin-top: 10px;
  }
  .modalmainpage:where(.DebtProcessedPopup, .WarrantProcessedPopup) .modalbody {
    width: 98.5%;
  }
  .modalmainpage:where(.DebtProcessedPopup, .WarrantProcessedPopup)
    .searchmadaltitlebar {
    margin-left: 0px;
  }
  .modalmainpage:where(.DebtProcessedPopup, .WarrantProcessedPopup)
    .modaltitle {
    margin-left: 10px;
  }
  .modalmainpage:where(.DebtProcessedPopup, .WarrantProcessedPopup) {
    height: 260px;
  }

  .modalmainpage.bellNotification {
    height: 37vh;
  }
}

@media (min-width: 1551px) and (max-width: 1800px) {
  #dialog_templateReject .MuiPaper-root {
    height: 50vh;
  }

  #dialog_templateReject #txt_reject {
    height: 26.5vh !important;
  }
}

@media (min-width: 1361px) and (max-width: 1550px) {
  #dialog_templateReject .MuiPaper-root {
    height: 50vh;
  }

  #dialog_templateReject #txt_reject {
    height: 23vh !important;
  }
}

.react-pdf__Page {
  display: flex !important;
  justify-content: center !important;
}

#printbatch_dialog_dataSaveWarning {
  z-index: 1500;
}
`, "",{"version":3,"sources":["webpack://./src/views/components/base/modal/ReactModal.css"],"names":[],"mappings":"AAAA;;;CAGC;;AAED;EACE,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;AACA;;;EAGE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;EACpC,qCAAqC;EACrC,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,cAAc;EACd,uBAAuB;EACvB,4DAA4D;EAC5D,oCAAoC;EACpC,gCAAgC;EAChC,qCAAqC;EACrC,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,oCAAoC;EACpC,iBAAiB;EACjB,gCAAgC;EAChC,sCAAsC;EACtC,qCAAqC;EACrC,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,oCAAoC;EACpC,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,oCAAoC;EACpC,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,oCAAoC;EACpC,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;GAGG;;AAEH;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,+CAA+C;EAC/C,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;EAGE,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,mCAAmC;EACnC,aAAa;EACb,SAAS;AACX;AACA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,sCAAsC;EACtC,gCAAgC;EAChC,8BAA8B;EAC9B,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,sCAAsC;EACtC,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,aAAa;EACb,WAAW;AACb;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;;;EAGE,aAAa;EACb,SAAS;AACX;AACA;;;;EAIE,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,aAAa;EACb,mCAAmC;EACnC,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,oCAAoC;EACpC,gCAAgC;EAChC,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kCAAkC;EAClC,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,oCAAoC;EACpC,qCAAqC;EACrC,kCAAkC;EAClC,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,mEAAmE;EACnE,QAAQ;AACV;AACA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8CAA8C;EAC9C,oBAAoB;EACpB,SAAS;EACT,0BAA0B;AAC5B;AACA;EACE,mBAAmB;AACrB;AACA;;;;;EAKE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,6BAA6B;EAC7B,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,QAAQ;AACV;AACA;;;EAGE,6CAA6C;EAC7C,yBAAyB;AAC3B;AACA;EACE,6CAA6C;EAC7C,yBAAyB;AAC3B;AACA;;;;;EAKE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,6CAA6C;EAC7C,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;;;EAGE,6BAA6B;EAC7B,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,2BAA2B;AAC7B;AACA;;;;;EAKE,kBAAkB;AACpB;AACA;;;;EAIE,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc;AAChB;AACA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;EACnB,oBAAoB;AACtB;AACA;;;;EAIE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AACA;;;EAGE,gBAAgB;AAClB;AACA;;;;;EAKE,aAAa;EACb,8BAA8B;AAChC;AACA;;;;;;EAME,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;;;;;;;EAOE,UAAU;AACZ;AACA;;;;;;;;EAQE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;;;;;;;;;;;;;EAaE,yDAAyD;AAC3D;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,iCAAiC;EACjC,aAAa;EACb,6BAA6B;EAC7B,cAAc;EACd,0CAA0C;EAC1C,cAAc;AAChB;AACA;EACE,aAAa;EACb,0CAA0C;EAC1C,WAAW;EACX,8BAA8B;EAC9B,oCAAoC;EACpC,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,iCAAiC;AACnC;AACA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,wCAAwC;EACxC,gCAAgC;EAChC,iBAAiB;EACjB,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf;uBACqB;AACvB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,sCAAsC;EACtC,kCAAkC;EAClC,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,uBAAuB;AACzB;;AAEA;;;;;EAKE,cAAc;EACd,mBAAmB;AACrB;AACA;;;;;;EAME,oCAAoC;EACpC,kBAAkB;EAClB,qCAAqC;EACrC,mCAAmC;EACnC,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;AACA;;;;;;EAME,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;EAC1B,iBAAiB;AACnB;AACA;;;;;;;EAOE,oCAAoC;EACpC,kBAAkB;EAClB,qCAAqC;EACrC,gCAAgC;EAChC,iBAAiB;EACjB,cAAc;EACd,gCAAgC;EAChC,oBAAoB;AACtB;AACA;;;;;;;EAOE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,oCAAoC;EACpC,kBAAkB;EAClB,sCAAsC;EACtC,kCAAkC;EAClC,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,WAAW;AACb;AACA;;;;;EAKE;mCACiC;;EAEjC,8BAA8B;AAChC;AACA;;;;;;EAME,aAAa;EACb,8BAA8B;EAC9B,oCAAoC;EACpC,sCAAsC;EACtC,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,kCAAkC;AACpC;AACA;;;;;;;EAOE,oCAAoC;EACpC,sCAAsC;EACtC,iCAAiC;EACjC,aAAa;EACb,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;;;EAGE,qCAAqC;EACrC,mCAAmC;AACrC;AACA;;;EAGE,6BAA6B;EAC7B,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,aAAa;EACb,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,0CAA0C;EAC1C,UAAU;EACV,6BAA6B;EAC7B,gCAAgC;EAChC,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;EACrB,8BAA8B;AAChC;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,wCAAwC;EACxC,gCAAgC;EAChC,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,sCAAsC;EACtC,kCAAkC;EAClC,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AACtB;AACA;;;EAGE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;;AAEA;;;EAGE,cAAc;AAChB;AACA;;;EAGE,oBAAoB;EACpB,cAAc;EACd,oBAAoB;AACtB;;AAEA;;;EAGE,cAAc;AAChB;AACA;;;EAGE,oBAAoB;EACpB,cAAc;EACd,oBAAoB;AACtB;;AAEA;;EAEE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;;;;;;EAME,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,YAAY;EACZ,UAAU;EACV,mCAAmC;EACnC,aAAa;EACb,SAAS;AACX;AACA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,sCAAsC;EACtC,gCAAgC;EAChC,8BAA8B;EAC9B,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;AACA,qBAAqB;AACrB,sBAAsB;AACtB;EACE,eAAe;EACf,YAAY;EACZ,UAAU;EACV,mCAAmC;EACnC,aAAa;EACb,SAAS;AACX;AACA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,sCAAsC;EACtC,gCAAgC;EAChC,8BAA8B;EAC9B,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;AACA,oBAAoB;;AAEpB;EACE,WAAW;EACX,yCAAyC;AAC3C;AACA;EACE,sCAAsC;EACtC,kCAAkC;EAClC,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;EACzC,qCAAqC;EACrC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,qBAAqB;IACrB,YAAY;EACd;EACA;IACE,0BAA0B;EAC5B;;EAEA;IACE,oBAAoB;EACtB;EACA;;;IAGE,YAAY;EACd;EACA;;;;;;;IAOE,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,oBAAoB;EACtB;;EAEA;;;IAGE,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;;;;IAIE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;EACA;;;IAGE,kBAAkB;EACpB;EACA;;;IAGE,gBAAgB;EAClB;EACA;;;;;;IAME,kBAAkB;EACpB;EACA;;IAEE,cAAc;EAChB;EACA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;EACA;;IAEE,gBAAgB;EAClB;EACA;;IAEE,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,qBAAqB;IACrB,YAAY;EACd;EACA;IACE,0BAA0B;EAC5B;EACA;;;IAGE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;;;;;;;IAOE,gBAAgB;EAClB;EACA;;;IAGE,YAAY;EACd;EACA;;;IAGE,cAAc;EAChB;EACA;;;IAGE,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;;EAEA;IACE,uBAAuB;EACzB;EACA;IACE,YAAY;EACd;EACA;;;IAGE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;;;;;;IAME,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;EACA;;IAEE,gBAAgB;EAClB;EACA;;IAEE,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,YAAY;EACd;EACA;;IAEE,gBAAgB;EAClB;EACA;;IAEE,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,YAAY;EACd;EACA;IACE,0BAA0B;EAC5B;EACA;;;IAGE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,cAAc;EAChB;EACA;;;IAGE,cAAc;EAChB;EACA;;;IAGE,oBAAoB;;IAEpB,cAAc;IACd,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;EACA;;;;IAIE,mBAAmB;EACrB;EACA;;;IAGE,mBAAmB;EACrB;EACA;;;;;;;IAOE,iBAAiB;EACnB;EACA;;;;;;IAME,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;EACA;;IAEE,gBAAgB;EAClB;EACA;;IAEE,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,aAAa;AACf","sourcesContent":["/*\nThis computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), \nis the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.\n*/\n\n.closebutton {\n  position: relative;\n}\n\na.gridLinkclass {\n  text-decoration-line: underline;\n  cursor: pointer;\n  color: var(--hyperlinkFont-color);\n}\n\n.modalmainpage {\n  display: block;\n  padding: 0 0.5%;\n  background-color: white;\n  height: 322px;\n  position: absolute;\n  /* margin-top: -5%; */\n  width: 59.2%;\n  z-index: 2002;\n  border-radius: 10px;\n}\n.modalmainpage.bellNotification {\n  padding: 0 1% 0 1%;\n}\n\n.modalmainpage.notestab {\n  height: 320px;\n}\n.modalmainpage.notestabAdd {\n  height: 340px;\n}\n\n.modalmainpage_approvalQueueList {\n  display: grid;\n  grid-template-rows: min-content 1fr min-content;\n  padding: 20px;\n  background-color: white;\n  height: 892px;\n  position: absolute;\n  width: 985px;\n  z-index: 2002;\n  border-radius: 10px;\n  gap: 20px;\n}\n\n.notes_dialog_dataSaveWarning {\n  z-index: 2003;\n}\n\n#dialog_templateReject {\n  z-index: 2006;\n}\n\n.modalmainpage .previewContainer_main {\n  height: 600px;\n}\n\n.modalbody {\n  z-index: 2002;\n  position: absolute;\n  height: 78%;\n  width: 100%;\n  margin-top: 0.5%;\n  margin-left: 1.25%;\n}\n\n.modalbodyApprovalQueue {\n  z-index: 2002;\n  height: 100%;\n  overflow: hidden;\n}\n.modalmainpage_approvalQueueList\n  .modalbodyApprovalQueue\n  .previewContainer_main {\n  height: 100%;\n  overflow: hidden;\n}\n\n.NotesTab .modalbody {\n  width: 96%;\n}\n\n.NotesTab .searchmadaltitlebar {\n  width: 98.5%;\n}\n\n.MuiDialogTitle-root .MuiTypography-h6 {\n  font-size: var(--dialogTitleFontSize);\n  font-family: var(--default-FontName);\n  font-weight: var(--header-FontWeight);\n  line-height: 1.6;\n  letter-spacing: 0.0075em;\n}\n\n.sendCorrespondenceAddress .modaltitle {\n  margin-top: 0 !important;\n}\n.modaltitle {\n  margin-top: 5%;\n  /* margin-left: 2.5%; */\n  font-size: var(--default-NotificationContentHeadingFontSize);\n  font-family: var(--default-FontName);\n  color: var(--default-FontColour);\n  font-weight: var(--header-FontWeight);\n  overflow: hidden;\n  height: auto;\n  text-wrap: wrap;\n}\n.modalmainpage_approvalQueueList .searchmadaltitlebar .modaltitle {\n  font-family: var(--default-FontName);\n  font-weight: bold;\n  color: var(--default-FontColour);\n  font-size: var(--mainheading-FontSize);\n  font-weight: var(--header-FontWeight);\n  margin-top: 0;\n  overflow-wrap: anywhere;\n  /* margin-left: 2.5%; */\n}\n\n.sendCorrespondenceAddress .closeicon {\n  margin-top: 0px !important;\n}\n\n.closeicon {\n  /* margin-right: 0.5%; */\n  cursor: pointer;\n  font-family: var(--default-FontName);\n  color: black;\n  /* font-weight: bold; */\n  margin-top: 40px;\n  margin-right: 3px;\n}\n.modalmainpage_approvalQueueList .searchmadaltitlebar .closeicon {\n  cursor: pointer;\n  font-family: var(--default-FontName);\n  color: black;\n  margin-top: 0;\n  margin-right: 0;\n}\n\n.butZoom {\n  display: flex;\n  align-items: center;\n  gap: 2.64vh;\n}\n\n.closeicon_reject {\n  cursor: pointer;\n  font-family: var(--default-FontName);\n  color: black;\n  /* font-weight: bold; */\n  margin-top: -7%;\n  margin-left: 100%;\n}\n\n/* #dialog_templateReject.MuiDialog-root.MuiModal-root .MuiDialog-container.MuiDialog-scrollPaper .MuiPaper-root {\n  width: 38.281vw;\n  height: 35.017vh;\n} */\n\n#dialog_templateReject .MuiDialogContent-root {\n  height: 14.514vh;\n}\n\n#dialog_templateReject .textbox {\n  height: 99%;\n}\n\n#dialog_templateReject .MuiPaper-root {\n  height: 45vh;\n  width: 50vw;\n  display: grid;\n  grid-template-rows: min-content 1fr min-content;\n  row-gap: 0px;\n}\n\n#dialog_templateReject #txt_reject {\n  height: 25.2vh !important;\n  width: 100%;\n  margin: 0px;\n}\n\n#dialog_templateReject .MuiDialogTitle-root {\n  padding-left: 0px;\n  padding-top: 8px;\n}\n\n#dialog_templateReject .MuiDialogContent-root,\n#dialog_templateReject .Text-field-container,\n#dialog_templateReject .multilinetextbox {\n  height: 100%;\n}\n\n#dialog_templateReject .MuiDialogContent-root .MuiInputBase-root,\n#dialog_templateReject .MuiDialogContent-root .MuiFormControl-root {\n  height: 100%;\n}\n\n.sendCorrespondenceAddress .searchmadaltitlebar {\n  width: unset;\n}\n.searchmadaltitlebar {\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  height: 15%;\n  margin-left: 1.25%;\n  width: 100%;\n  justify-content: space-between;\n}\n\n.modalmainpage_approvalQueueList .searchmadaltitlebar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  height: auto;\n  width: 100% !important;\n  margin: 0px !important;\n}\n\n.modalmainpage_approvalQueueList .previewContainer {\n  height: 100%;\n  overflow-y: auto;\n  margin: 0px 0px 0px 0px;\n  border: 1px solid #bcbcbc;\n  border-radius: 4px;\n}\n\n.modalmainpage_approvalQueueList .sendCorrespondenceSaveCancel {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.notesmaindiv {\n  padding-top: 2%;\n  height: 100%;\n  width: 100%;\n  grid-template-rows: min-content 1fr;\n  display: grid;\n  gap: 10px;\n}\n.notesmaindiv .textbox {\n  display: grid;\n  align-content: space-around;\n}\n\n.notesmaindiv .MuiInputBase-root #txt_notesdescription.Mui-disabled {\n  font-size: var(--default-FontSize);\n  font-family: var(--default-FontName);\n  font-weight: var(--default-FontWeight);\n  color: var(--default-FontColour);\n  -webkit-text-fill-color: unset;\n  height: 168px !important;\n  overflow: auto !important;\n  padding: 5px 0px 0px -1px;\n}\n\n.notesmaindiv .textbox .MuiFormControl-root .MuiInputBase-root {\n  margin-top: 10px;\n}\n\n.addNotesmaindiv .addNotes {\n  height: 131px;\n  width: 100%;\n}\n\n.modalbody .addNotesmaindiv {\n  height: 322px;\n}\n\n#txt_note {\n  height: 131px !important;\n  min-height: 131px !important;\n  width: 100%;\n  resize: none;\n  border-style: hidden;\n}\n\n.modalmainpage.sendCorrespondenceAddress .modalbody {\n  width: 96%;\n}\n.modalmainpage.sendCorrespondenceAddress .searchmadaltitlebar .closeicon {\n  margin-right: 7px;\n}\n.modalmainpage.notestabAdd .modalbody {\n  width: 96%;\n}\n.modalmainpage.notestabAdd .searchmadaltitlebar .closeicon {\n  margin-right: 20px;\n}\n\n.addNotesmaindiv .span_Label {\n  font-size: var(--default-FontSize);\n  font-family: var(--default-FontName);\n  font-weight: var(--default-FontWeight);\n  color: var(--default-FontColour);\n  margin-top: 5px;\n}\n\n#dialog_templateReject {\n  font-family: var(--default-FontName);\n}\n\n.MuiDialogTitle-root {\n  margin-left: -28px;\n  font-family: var(--default-FontName);\n}\n\n.addNotesmaindiv .required {\n  color: var(--required-color);\n}\n\n.addNotesmaindiv .addNotesButton {\n  float: right;\n  display: flex;\n  gap: 15px;\n}\n\n.addNotessubheaderdiv {\n  margin-top: 20px;\n  margin-bottom: 15px;\n}\n\n.notes.dataSaveWarning.MuiModal-root {\n  z-index: 2007 !important;\n}\n\n.sendCorrespondenceAddress .sendCorrespondenceAddressButton {\n  float: right;\n  display: flex;\n  gap: 12px;\n  margin-top: 21px;\n}\n\n.sendCorrespondenceAddress .sendCorrespondenceAddressGrid {\n  height: 260px;\n}\n\n.modalmainpage.sendCorrespondenceAddress {\n  height: 405px;\n}\n\n.modalmainpage_approvalQueueList .zoomInicon {\n  cursor: pointer;\n}\n\n.modalmainpage_approvalQueueList .zoomOuticon {\n  cursor: pointer;\n}\n\n.title_reject {\n  font-size: var(--sub-header-FontSize);\n  font-family: var(--default-FontName);\n}\n\n#txt_reject {\n  resize: none;\n}\n\n.MuiDialog-root.MuiModal-root {\n  z-index: 2008;\n}\n\ndiv[disabled] {\n  pointer-events: none;\n  opacity: 0.7;\n}\n.modalmainpage_approvalQueueList .searchmadaltitlebar .headericonright {\n  display: flex;\n  gap: 2.64vh;\n}\n.modalmainpage_approvalQueueList .approvalQueueButtons {\n  display: flex;\n  justify-content: space-between;\n}\n.modalmainpage_approvalQueueList\n  .approvalQueueButtons\n  .approvalQueueButtonsLeft {\n  display: flex;\n  gap: 10px;\n}\n.bellNotification.modalmainpage\n  .searchmadaltitlebar\n  .closeicon\n  .MuiSvgIcon-root {\n  font-size: 1.5rem;\n}\n.divMainBellNotificationMessage {\n  height: 100%;\n  display: grid;\n  grid-template-rows: 1fr min-content;\n  gap: 5px;\n  padding-top: 20px;\n}\n\n.divMainBellNotificationMessage .divBellNotificationMessage {\n  font-size: var(--default-FontSize);\n  font-style: normal;\n  font-weight: var(--label-FontWeight);\n  font-size: var(--label-FontSize);\n  line-height: 21px;\n  color: #333333;\n  white-space: break-spaces;\n  text-align: justify;\n  /* margin-top: 30px; */\n  overflow: auto;\n  /* height: 60%; */\n}\n.divBellNotificationMessage .bellNotificationMessageText {\n  margin-top: 10px;\n  word-break: break-word;\n  line-height: 29px;\n}\n.modalmainpage.bellNotification .searchmadaltitlebar {\n  height: 20%;\n}\n.modalmainpage.bellNotification {\n  width: 735px;\n  height: 30vh;\n  background: #ffffff;\n  border-radius: 8px;\n}\n.bellNotification .modalbody {\n  margin: 0px;\n  width: 100%;\n  padding: 0px 10px 0px 10px;\n  position: relative;\n}\n\n.divMainBellNotificationMessage .notificationContentDate {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  font-size: var(--default-FontSize);\n  color: #333333;\n  margin: 0px 0px 15px 0px;\n}\n\n.addZone_field_col {\n  display: grid;\n  grid-template-columns: 180px auto;\n  font-family: var(--default-FontName);\n  font-weight: var(--header-FontWeight);\n  font-size: var(--default-FontSize);\n  line-height: 35px;\n  width: 100% !important;\n  margin-right: 300px;\n  /* margin: 7px 0px 0px 0px; */\n  height: 56px;\n}\n\n.modalmainpage.addZone {\n  width: 765px;\n  /* height: 47.1vh; */\n  height: auto;\n}\n.backdrop.MuiBackdrop-root {\n  z-index: 2007 !important;\n}\n\n.divZonePopup {\n  margin: 30px 30px 0px 20px;\n  display: grid;\n  grid-template-rows: min-content min-content min-content min-content;\n  gap: 7px;\n}\n.divZonePopup .mandatorySymbol {\n  color: #ff0000;\n}\n\n.divZoneMainPopup .divZoneButton {\n  display: grid;\n  grid-template-columns: min-content min-content;\n  justify-content: end;\n  gap: 10px;\n  padding: 20px 30px 0px 0px;\n}\n.divZoneMainPopup .autoCompleteLazyLoadctrl .colWiseControl {\n  gap: 0px !important;\n}\n.divZoneMainPopup\n  .divZonePopup\n  .addZone_field_col\n  .autoCompleteLazyLoadctrl\n  .fieldAlert {\n  display: block;\n  height: fit-content;\n}\n.modalmainpage.addZone .searchmadaltitlebar {\n  display: flex;\n  justify-content: space-around;\n  gap: 520px;\n}\n.modalmainpage.addZone .searchmadaltitlebar .closeicon {\n  margin-right: 7px;\n  cursor: pointer;\n}\n\n.MuiBackdrop-root.backdrop.addZoneBackdrop {\n  z-index: 1000 !important;\n}\n.MuiBackdrop-root.backdrop.WarrantExecutedPopupBackdrop {\n  z-index: 1000 !important;\n}\n\n.divZonePopup .MuiFormLabel-root {\n  display: none !important;\n}\n\n.divZonePopup .textbox .colWiseControl {\n  gap: 3px;\n}\n.divZoneMainPopup\n  .divZonePopup\n  .MuiInputBase-root.MuiInput-root.MuiInput-underline.MuiInputBase-colorPrimary.MuiInputBase-formControl.MuiInputBase-sizeSmall.MuiInputBase-adornedStart.MuiInputBase-adornedEnd {\n  background-color: var(--inputbackgroundColor);\n  border: 1px solid #b6b6b6;\n}\n.divZoneMainPopup .divZonePopup input#ac_inputAutocompleteLazyLoad {\n  background-color: var(--inputbackgroundColor);\n  border: 0px solid #b6b6b6;\n}\n.divZoneMainPopup\n  .divZonePopup\n  .addZone_field_col\n  .autoCompleteLazyLoadctrl\n  .autoCompleteLazyLoadinputDiv {\n  border: 1px solid;\n  display: flex;\n  flex-direction: row;\n  background-color: var(--inputbackgroundColor);\n  border: 1px solid #b6b6b6;\n  box-sizing: border-box;\n  border-radius: 4px;\n  align-items: center;\n}\n\n.modalmainpage.addZone .modalbody {\n  position: relative;\n  padding: 0% 0% 4% 0%;\n}\n\n.modalmainpage.addZone .modaltitle {\n  margin-left: -2%;\n}\n\n.modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)\n  .searchmadaltitlebar\n  .modaltitle {\n  font-weight: var(--header-FontWeight);\n  font-size: var(--pcnHeaderFontSize);\n}\n\n.modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup) {\n  width: 750px;\n  height: auto;\n  padding: 0% 1% 1.8% 1%;\n}\n.modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup) .modalbody {\n  position: initial;\n  height: auto;\n}\n.modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)\n  .modalbody\n  .messageModalRadio {\n  border-top: 1px solid #ececec;\n  border-bottom: 1px solid #ececec;\n  width: 700px;\n  height: auto;\n  margin: 2% 0% 0% 0%;\n  display: grid;\n  align-content: space-evenly;\n}\n.modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)\n  .modalbody\n  .messageModalRadio\n  .RadioGroupControl\n  span.MuiTypography-root.MuiTypography-body1.MuiFormControlLabel-label {\n  margin-right: 96px;\n}\n.modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)\n  .modalbody\n  .messageModalRadio\n  .RadioGroupControl {\n  margin: 3% 0% 3% 0%;\n}\n\n.modalmainpage.modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)\n  .searchmadaltitlebar\n  .modaltitle {\n  margin-top: 1%;\n}\n.modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)\n  .searchmadaltitlebar\n  .closeicon {\n  margin-top: 10px;\n}\n\n.divWarrantExecutedPopupButton {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  margin: 3% 0% 0% 0%;\n  padding: 0% 3% 0% 0%;\n}\n.modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)\n  .modalbody\n  .divWarrantExecutedPopupButton\n  .WarrantExecutedPopupSaveCancel {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n}\n.modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)\n  .searchmadaltitlebar\n  .closeicon {\n  margin-right: 1%;\n}\n.modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)\n  .modalbody\n  .messageModalRadio\n  .divSomeRejected\n  .divSearchCase {\n  display: flex;\n  justify-content: space-between;\n}\n.modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)\n  .modalbody\n  .messageModalRadio\n  .divSomeRejected\n  .divSearchCase\n  .divbtnSearchCase {\n  display: flex;\n  gap: 10px;\n  margin: 3% 0% 0% 0%;\n}\n.divtxtSearchCase {\n  width: 100%;\n  margin: 3% 0% 0% 0%;\n}\n.modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)\n  .modalbody\n  .messageModalRadio\n  .divSomeRejected\n  .divSearchCase\n  .divtxtSearchCase\n  .textbox {\n  width: 98%;\n}\n.modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)\n  .modalbody\n  .messageModalRadio\n  .divSomeRejected\n  .divSearchCase\n  .divtxtSearchCase\n  .textbox\n  .MuiInputBase-root {\n  height: 40px;\n  background: #fbfbfb;\n  border: 1px solid #b6b6b6;\n  border-radius: 4px;\n}\n.divSomeRejected\n  .divSearchCase\n  .divtxtSearchCase\n  .textbox\n  input:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ntextarea:-webkit-autofill,\ntextarea:-webkit-autofill:hover,\ntextarea:-webkit-autofill:focus,\nselect:-webkit-autofill,\nselect:-webkit-autofill:hover,\nselect:-webkit-autofill:focus {\n  -webkit-box-shadow: 0 0 0 1000px #fbfbfb inset !important;\n}\n.divSomeRejected .divSearchResultMain {\n  border: 1px solid #b6b6b6;\n  border-radius: 6px;\n  margin: 3% 0% 0% 0%;\n}\n.divSearchResultMain .divNoRecords {\n  font-family: var(--default-FontName);\n  font-weight: var(--default-FontWeight);\n  font-size: var(--tooltipFontSize);\n  display: flex;\n  justify-content: space-around;\n  color: #b6b6b6;\n  /* padding: 1.03vh 1.56vw 1.03vh 1.56vw; */\n  height: 38.5px;\n}\n.divSomeRejected .divSearchResult {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1.2fr 0.8fr;\n  width: 100%;\n  justify-content: space-between;\n  padding: 2.06vh 1.56vw 2.06vh 1.56vw;\n  align-items: flex-end;\n}\n.divAddSearchResult .btn--primary.button.MuiButton-root {\n  width: 112px;\n  padding: 11px 6px;\n  gap: 10px;\n}\n.divSomeRejected .divSearchResult.divSearchResultNoRecords {\n  padding: 2.06vh 1.56vw 0px 1.56vw;\n}\n.divSomeRejected .divSearchResult .divSearchResultHeading {\n  font-family: var(--default-FontName);\n  font-style: normal;\n  font-weight: var(--listHeaderFontWeight);\n  font-size: var(--label-FontSize);\n  line-height: 21px;\n  color: #333333;\n  border-right: 1px solid #ececec;\n  margin-left: 5%;\n  /* margin-top: 5%;\n  margin-bottom: 15%; */\n}\n.divSomeRejected .divSearchResult .divSearchResultSub {\n  display: flex;\n  flex-direction: column;\n  gap: 1.55vh;\n}\n.divSomeRejected .divSearchResult .divSearchResultData {\n  font-family: var(--default-FontName);\n  font-style: normal;\n  font-weight: var(--default-FontWeight);\n  font-size: var(--default-FontSize);\n  line-height: 21px;\n  color: #333333;\n  margin-left: 5%;\n  /* margin-bottom: 5%; */\n}\n\n.modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)\n  .modalbody\n  .messageModalRadio\n  .divSomeRejected\n  .divAddSearchResult {\n  direction: rtl;\n  margin: 2% 0% 0% 0%;\n}\n.modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)\n  .modalbody\n  .messageModalRadio\n  .divSomeRejected\n  .divRejectMain\n  .divRejectTitle {\n  font-family: var(--default-FontName);\n  font-style: normal;\n  font-weight: var(--header-FontWeight);\n  font-size: var(--pcnHeaderFontSize);\n  line-height: 24px;\n  color: #333333;\n  margin: 0% 0% 1% 0%;\n}\n.modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)\n  .modalbody\n  .messageModalRadio\n  .divSomeRejected\n  .divRejectMain\n  .divRejectSub {\n  border: 1px solid #b6b6b6;\n  border-radius: 6px;\n  padding: 0px 10px 0px 10px;\n  margin-bottom: 3%;\n}\n.modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)\n  .modalbody\n  .messageModalRadio\n  .divSomeRejected\n  .divRejectMain\n  .divRejectSub\n  .divRejectSubTitle {\n  font-family: var(--default-FontName);\n  font-style: normal;\n  font-weight: var(--header-FontWeight);\n  font-size: var(--label-FontSize);\n  line-height: 21px;\n  color: #333333;\n  border-bottom: 1px solid #ececec;\n  padding: 1% 0% 1% 0%;\n}\n.modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)\n  .modalbody\n  .messageModalRadio\n  .divSomeRejected\n  .divRejectMain\n  .divRejectSub\n  .divRejectList {\n  display: grid;\n  /* justify-content: space-between; */\n  margin: 2% 0% 2% 0%;\n  font-family: var(--default-FontName);\n  font-style: normal;\n  font-weight: var(--default-FontWeight);\n  font-size: var(--default-FontSize);\n  line-height: 21px;\n  color: #333333;\n  max-height: 280px;\n  min-height: 28px;\n  overflow: auto;\n}\n\n.divSomeRejected\n  .divAddSearchResult\n  span.MuiButton-endIcon.MuiButton-iconSizeMedium {\n  margin: 0px;\n}\n.divSomeRejected\n  .divRejectMain\n  .divRejectSub\n  .divRejectList\n  .divRejectListItem {\n  /* display: flex;\n  justify-content: space-between; */\n\n  justify-content: space-between;\n}\n.divSomeRejected\n  .divRejectMain\n  .divRejectSub\n  .divRejectList\n  .divRejectListItem\n  .divRejectListItemRow {\n  display: flex;\n  justify-content: space-between;\n  font-family: var(--default-FontName);\n  font-weight: var(--default-FontWeight);\n  font-size: var(--default-FontSize);\n}\n.divRejectListItemRow.divNoRecordsMain {\n  display: flex;\n  justify-content: center !important;\n}\n.divSomeRejected\n  .divRejectMain\n  .divRejectSub\n  .divRejectList\n  .divRejectListItem\n  .divRejectListItemRow\n  .divNoRecords {\n  font-family: var(--default-FontName);\n  font-weight: var(--default-FontWeight);\n  font-size: var(--tooltipFontSize);\n  display: flex;\n  justify-content: space-around;\n  color: #b6b6b6;\n}\n\n.modalmainpage:where(.DebtExecuted) {\n  width: 39.58vw;\n  height: 26.63vh;\n  padding: 0% 1% 2% 1%;\n}\n\n.modalmainpage:where(.WarrantProcessedPopup, .DebtExecuted)\n  .searchmadaltitlebar\n  .modaltitle {\n  font-weight: var(--header-FontWeight);\n  font-size: var(--pcnHeaderFontSize);\n}\n.modalmainpage:where(.WarrantProcessedPopup, .DebtExecuted)\n  .modalbody\n  .messageModalRadio {\n  border-top: 1px solid #ececec;\n  border-bottom: 1px solid #ececec;\n  width: 700px;\n  height: auto;\n  margin: 2% 0% 2.5% 0%;\n  display: grid;\n  align-content: space-evenly;\n}\n.divWarrantExecutedMain .divSearchResult {\n  display: grid;\n  grid-template-columns: 1.5fr 1fr 1fr 0.5fr;\n  width: 98%;\n  border-top: 1px solid #ececec;\n  border-bottom: 1px solid #ececec;\n  margin: 3% 0% 0% 0%;\n  padding: 0px 0px 8px 0px;\n  align-items: flex-end;\n  justify-content: space-between;\n}\n.modalmainpage:where(.WarrantProcessedPopup, .DebtExecuted) .modalbody {\n  position: initial;\n  height: auto;\n}\n.divWarrantExecutedMain .divSearchResult .divSearchResultHeading {\n  font-family: var(--default-FontName);\n  font-style: normal;\n  font-weight: var(--listHeaderFontWeight);\n  font-size: var(--label-FontSize);\n  line-height: 21px;\n  color: #333333;\n  margin-top: 1.5vh;\n  margin-bottom: 1.678vh;\n}\n.divWarrantExecutedMain .divSearchResult .divSearchResultData {\n  font-family: var(--default-FontName);\n  font-style: normal;\n  font-weight: var(--default-FontWeight);\n  font-size: var(--default-FontSize);\n  line-height: 21px;\n  color: #333333;\n  margin-bottom: 1.5vh;\n}\n.modalmainpage:where(.WarrantProcessedPopup, .DebtExecuted)\n  .searchmadaltitlebar\n  .closeicon {\n  margin-right: 1.3%;\n}\n\n.svg-buttonActive {\n  cursor: pointer;\n}\n.hideMainPopup .modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup) {\n  display: none;\n}\n\n.modalmainpage:where(.WarrantProcessedPopup, .DebtExecuted)\n  .searchmadaltitlebar\n  .modaltitle {\n  margin-top: 0%;\n}\n.modalmainpage:where(.WarrantProcessedPopup, .DebtExecuted)\n  .searchmadaltitlebar\n  .closeicon {\n  /* margin-top: 3%; */\n  margin-top: 0%;\n  align-self: self-end;\n}\n\n.modalmainpage:where(.WarrantProcessedPopup, .DebtExecuted)\n  .searchmadaltitlebar\n  .modaltitle {\n  margin-top: 0%;\n}\n.modalmainpage:where(.WarrantProcessedPopup, .DebtExecuted)\n  .searchmadaltitlebar\n  .closeicon {\n  /* margin-top: 3%; */\n  margin-top: 0%;\n  align-self: self-end;\n}\n\n.modalmainpage:where(.WarrantProcessedPopup, .DebtExecuted)\n  .searchmadaltitlebar {\n  margin-top: 2%;\n}\n.modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)\n  .searchmadaltitlebar {\n  margin-top: 2%;\n}\n.modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)\n  .modalbody\n  .messageModalRadio\n  .RadioGroupControl\n  .radioGroupControl\n  .MuiFormControlLabel-root {\n  margin-right: 16px;\n}\n\n.modalmainpage.bellNotification .searchmadaltitlebar .closeicon {\n  margin-top: 40px;\n  margin-right: 15px;\n}\n.modalmainpage.SearchBar {\n  height: 70vh;\n  width: 85vw;\n}\n.modalmainpage.SearchBar .modalbody .searchBarModalbody {\n  height: 58vh;\n  width: 82vw;\n  margin-top: 5px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n.modalmainpage.SearchBar .searchmadaltitlebar .modaltitle {\n  margin-top: 15px;\n}\n.modalmainpage.SearchBar .searchmadaltitlebar .closeicon {\n  margin-top: 15px;\n  margin-right: 25px;\n}\n\n.modalmainpage:where(.DebtProcessedPopup, .WarrantProcessedPopup) .modalbody {\n  width: 98.5%;\n}\n.modalmainpage:where(.DebtProcessedPopup, .WarrantProcessedPopup)\n  .searchmadaltitlebar {\n  margin-left: 0px;\n}\n.modalmainpage:where(.DebtProcessedPopup, .WarrantProcessedPopup) .modaltitle {\n  margin-left: 10px;\n}\n.modalmainpage:where(.DebtProcessedPopup, .WarrantProcessedPopup) {\n  height: 300px;\n}\n\n/* DomainURL -- Start */\n.addDomainURLDiv {\n  padding-top: 2%;\n  height: 100%;\n  width: 91%;\n  grid-template-rows: min-content 1fr;\n  display: grid;\n  gap: 20px;\n}\n.addDomainURLDiv .textbox {\n  display: grid;\n  align-content: space-around;\n}\n\n.addDomainURLDiv .MuiInputBase-root #txt_notesdescription.Mui-disabled {\n  font-size: var(--default-FontSize);\n  font-family: var(--default-FontName);\n  font-weight: var(--default-FontWeight);\n  color: var(--default-FontColour);\n  -webkit-text-fill-color: unset;\n  height: 168px !important;\n  overflow: auto !important;\n  padding: 5px 0px 0px -1px;\n}\n\n.addDomainURLDiv .textbox .MuiFormControl-root .MuiInputBase-root {\n  margin-top: 20px;\n}\n\n.addDomainURLDiv .domainURLPopupSaveCancel {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n/* DomainURL -- End */\n/* Branding -- Start */\n.brandingURLDiv {\n  padding-top: 2%;\n  height: 100%;\n  width: 62%;\n  grid-template-rows: min-content 1fr;\n  display: grid;\n  gap: 20px;\n}\n.brandingURLDiv .textbox {\n  display: grid;\n  align-content: space-around;\n}\n\n.brandingURLDiv .MuiInputBase-root #txt_notesdescription.Mui-disabled {\n  font-size: var(--default-FontSize);\n  font-family: var(--default-FontName);\n  font-weight: var(--default-FontWeight);\n  color: var(--default-FontColour);\n  -webkit-text-fill-color: unset;\n  height: 168px !important;\n  overflow: auto !important;\n  padding: 5px 0px 0px -1px;\n}\n\n.brandingURLDiv .textbox .MuiFormControl-root .MuiInputBase-root {\n  margin-top: 20px;\n}\n\n.brandingPopupSaveCancel {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n/* Branding -- End */\n\n.divLine {\n  width: 100%;\n  border: 1px solid var(--line-BorderColor);\n}\n.divMainBellNotificationMessage .divOrgContract {\n  font-weight: var(--default-FontWeight);\n  font-size: var(--default-FontSize);\n  color: #333333;\n  display: flex;\n  margin: 15px 0px 15px 0px;\n  align-items: center;\n  column-gap: 140px;\n  line-height: 25px;\n}\n\n.divNotificationTitle {\n  font-weight: var(--dialogTitleFontWeight);\n  font-size: var(--dialogTitleFontSize);\n  color: #333333;\n  display: flex;\n  align-items: center;\n  column-gap: 10px;\n}\n\n@media (min-width: 491px) and (max-width: 1024px) {\n  .modalmainpage_approvalQueueList {\n    height: 570px;\n  }\n  .modalmainpage.addZone {\n    /* height: 71.14vh; */\n    height: auto;\n  }\n  .divZoneMainPopup .divZoneButton {\n    padding: 20px 30px 0px 0px;\n  }\n\n  .divWarrantExecutedPopupButton {\n    padding: 0% 2% 0% 0%;\n  }\n  .modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)\n    .modalbody\n    .messageModalRadio {\n    width: 712px;\n  }\n  .modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)\n    .modalbody\n    .messageModalRadio\n    .divSomeRejected\n    .divRejectMain\n    .divRejectSub\n    .divRejectList {\n    max-height: 50px;\n  }\n  .modalmainpage:where(.WarrantProcessedPopup, .DebtExecuted) {\n    height: 33vh;\n    padding: 0% 0% 0% 1%;\n  }\n\n  .modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)\n    .modalbody\n    .divWarrantExecutedPopupButton {\n    margin: 2% 0% 0% 0%;\n  }\n  .modalmainpage:where(.WarrantProcessedPopup, .DebtExecuted) .modalbody {\n    width: 98%;\n  }\n  .modalmainpage:where(.WarrantProcessedPopup, .DebtExecuted)\n    .modalbody\n    .divWarrantExecutedMain\n    .divWarrantExecutedPopupButton {\n    margin: 2% 0% 0% 0%;\n  }\n\n  .modalmainpage:where(.WarrantProcessedPopup, .DebtExecuted) {\n    width: 55.58vw;\n  }\n  .modalmainpage:where(.WarrantProcessedPopup, .DebtExecuted)\n    .searchmadaltitlebar\n    .closeicon {\n    margin-right: 1.5%;\n  }\n  .modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)\n    .searchmadaltitlebar\n    .closeicon {\n    margin-right: 2%;\n  }\n  .modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)\n    .modalbody\n    .messageModalRadio\n    .RadioGroupControl\n    .radioGroupControl\n    .MuiFormControlLabel-root {\n    margin-right: 38px;\n  }\n  .modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)\n    .searchmadaltitlebar {\n    margin-top: 0%;\n  }\n  .modalmainpage.SearchBar .searchmadaltitlebar .closeicon {\n    margin-top: 22px;\n    margin-right: 10px;\n  }\n\n  .modalmainpage:where(.DebtProcessedPopup, .WarrantProcessedPopup) .modalbody {\n    width: 98.5%;\n  }\n  .modalmainpage:where(.DebtProcessedPopup, .WarrantProcessedPopup)\n    .searchmadaltitlebar {\n    margin-left: 0px;\n  }\n  .modalmainpage:where(.DebtProcessedPopup, .WarrantProcessedPopup)\n    .modaltitle {\n    margin-left: 10px;\n  }\n  .modalmainpage:where(.DebtProcessedPopup, .WarrantProcessedPopup) {\n    height: 220px;\n  }\n  .modalmainpage.bellNotification {\n    height: 44vh;\n  }\n}\n\n@media (min-width: 1025px) and (max-width: 1360px) {\n  .modalmainpage_approvalQueueList {\n    height: 580px;\n  }\n  .modalmainpage.addZone {\n    /* height: 70.14vh; */\n    height: auto;\n  }\n  .divZoneMainPopup .divZoneButton {\n    padding: 20px 30px 0px 0px;\n  }\n  .modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)\n    .searchmadaltitlebar\n    .closeicon {\n    margin-right: 2%;\n  }\n  .divWarrantExecutedPopupButton {\n    padding: 0% 2.5% 0% 0%;\n  }\n  .modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)\n    .modalbody\n    .messageModalRadio\n    .divSomeRejected\n    .divRejectMain\n    .divRejectSub\n    .divRejectList {\n    max-height: 50px;\n  }\n  .modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)\n    .modalbody\n    .messageModalRadio {\n    width: 705px;\n  }\n  .modalmainpage:where(.WarrantProcessedPopup, .DebtExecuted)\n    .searchmadaltitlebar\n    .modaltitle {\n    margin-top: 0%;\n  }\n  .modalmainpage:where(.WarrantProcessedPopup, .DebtExecuted)\n    .searchmadaltitlebar\n    .closeicon {\n    margin-top: 0%;\n    margin-right: 1%;\n  }\n  .divWarrantExecutedMain .divSearchResult {\n    margin: 3% 0% 0% 0%;\n  }\n  #dialog_templateReject .MuiPaper-root {\n    height: 50vh;\n  }\n\n  #dialog_templateReject #txt_reject {\n    height: 22vh !important;\n  }\n  .modalmainpage:where(.WarrantProcessedPopup, .DebtExecuted) {\n    height: 32vh;\n  }\n  .modalmainpage:where(.WarrantExecutedPopup, .DebtDebtExecutedPopupProcessed)\n    .modalbody\n    .divWarrantExecutedPopupButton {\n    margin: 2% 0% 0% 0%;\n  }\n  .divWarrantExecutedPopupButton {\n    margin: 3% 0% 0% 0%;\n  }\n  .modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)\n    .modalbody\n    .messageModalRadio\n    .RadioGroupControl\n    .radioGroupControl\n    .MuiFormControlLabel-root {\n    margin-right: 35px;\n  }\n  .modalmainpage.SearchBar .searchmadaltitlebar .closeicon {\n    margin-top: 20px;\n    margin-right: 17px;\n  }\n\n  .modalmainpage:where(.DebtProcessedPopup, .WarrantProcessedPopup) .modalbody {\n    width: 98.5%;\n  }\n  .modalmainpage:where(.DebtProcessedPopup, .WarrantProcessedPopup)\n    .searchmadaltitlebar {\n    margin-left: 0px;\n  }\n  .modalmainpage:where(.DebtProcessedPopup, .WarrantProcessedPopup)\n    .modaltitle {\n    margin-left: 10px;\n  }\n  .modalmainpage:where(.DebtProcessedPopup, .WarrantProcessedPopup) {\n    height: 240px;\n  }\n  .modalmainpage.bellNotification {\n    height: 44vh;\n  }\n}\n\n@media (min-width: 1361px) and (max-width: 1536px) {\n  .modalmainpage.SearchBar .searchmadaltitlebar .modaltitle {\n    margin-top: 7px !important;\n  }\n\n  .modalmainpage:where(.DebtProcessedPopup, .WarrantProcessedPopup) .modalbody {\n    width: 98.5%;\n  }\n  .modalmainpage:where(.DebtProcessedPopup, .WarrantProcessedPopup)\n    .searchmadaltitlebar {\n    margin-left: 0px;\n  }\n  .modalmainpage:where(.DebtProcessedPopup, .WarrantProcessedPopup)\n    .modaltitle {\n    margin-left: 10px;\n  }\n  .modalmainpage:where(.DebtProcessedPopup, .WarrantProcessedPopup) {\n    height: 255px;\n  }\n  .modalmainpage.bellNotification {\n    height: 36vh;\n  }\n}\n\n@media (min-width: 1361px) and (max-width: 1600px) {\n  .modalmainpage_approvalQueueList {\n    height: 685px;\n  }\n  .modalmainpage.addZone {\n    /* height: 58vh; */\n    height: auto;\n  }\n  .divZoneMainPopup .divZoneButton {\n    padding: 15px 30px 0px 0px;\n  }\n  .modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)\n    .searchmadaltitlebar\n    .closeicon {\n    margin-right: 2%;\n  }\n  .divWarrantExecutedPopupButton {\n    padding: 0% 2.5% 0% 0%;\n  }\n  .modalmainpage:where(.WarrantProcessedPopup, .DebtExecuted) {\n    height: 29.5vh;\n  }\n  .modalmainpage:where(.WarrantProcessedPopup, .DebtExecuted)\n    .searchmadaltitlebar\n    .modaltitle {\n    margin-top: 0%;\n  }\n  .modalmainpage:where(.WarrantProcessedPopup, .DebtExecuted)\n    .searchmadaltitlebar\n    .closeicon {\n    /* margin-top: 3%; */\n\n    margin-top: 0%;\n    align-self: self-end;\n  }\n\n  .divWarrantExecutedMain .divSearchResult {\n    margin: 3% 0% 0% 0%;\n  }\n  .modalmainpage:where(.WarrantProcessedPopup, .DebtExecuted)\n    .modalbody\n    .divWarrantExecutedMain\n    .divWarrantExecutedPopupButton {\n    margin: 3% 0% 0% 0%;\n  }\n  .modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)\n    .modalbody\n    .divWarrantExecutedPopupButton {\n    margin: 3% 0% 0% 0%;\n  }\n  .modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)\n    .modalbody\n    .messageModalRadio\n    .divSomeRejected\n    .divRejectMain\n    .divRejectSub\n    .divRejectList {\n    max-height: 145px;\n  }\n  .modalmainpage:where(.WarrantExecutedPopup, .DebtExecutedPopup)\n    .modalbody\n    .messageModalRadio\n    .RadioGroupControl\n    .radioGroupControl\n    .MuiFormControlLabel-root {\n    margin-right: 28px;\n  }\n  .modalmainpage.SearchBar .searchmadaltitlebar .modaltitle {\n    margin-top: 10px;\n  }\n  .modalmainpage:where(.DebtProcessedPopup, .WarrantProcessedPopup) .modalbody {\n    width: 98.5%;\n  }\n  .modalmainpage:where(.DebtProcessedPopup, .WarrantProcessedPopup)\n    .searchmadaltitlebar {\n    margin-left: 0px;\n  }\n  .modalmainpage:where(.DebtProcessedPopup, .WarrantProcessedPopup)\n    .modaltitle {\n    margin-left: 10px;\n  }\n  .modalmainpage:where(.DebtProcessedPopup, .WarrantProcessedPopup) {\n    height: 260px;\n  }\n\n  .modalmainpage.bellNotification {\n    height: 37vh;\n  }\n}\n\n@media (min-width: 1551px) and (max-width: 1800px) {\n  #dialog_templateReject .MuiPaper-root {\n    height: 50vh;\n  }\n\n  #dialog_templateReject #txt_reject {\n    height: 26.5vh !important;\n  }\n}\n\n@media (min-width: 1361px) and (max-width: 1550px) {\n  #dialog_templateReject .MuiPaper-root {\n    height: 50vh;\n  }\n\n  #dialog_templateReject #txt_reject {\n    height: 23vh !important;\n  }\n}\n\n.react-pdf__Page {\n  display: flex !important;\n  justify-content: center !important;\n}\n\n#printbatch_dialog_dataSaveWarning {\n  z-index: 1500;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
